import { useAuthUser } from "@features/auth";
import { useDraftOrderSetsQuery } from "@features/orders/queries";

import useDraftOrderSetFromList from "./useDraftOrderSetFromList";

export const useDraftOrderSetQuery = (
  orderType: "from-inventory" | "on-demand"
) => {
  const { channel, territory } = useAuthUser();

  return useDraftOrderSetFromList(useDraftOrderSetsQuery(), {
    orderType,
    channel,
    territory,
  });
};

export default useDraftOrderSetQuery;
